<template>
<div class="mapWidth">
  <div id="UsMap-wrapper-container">
      <v-overlay :value="mapLoader">
          <v-progress-circular color='white' indeterminate size="64"></v-progress-circular>
      </v-overlay>
          <div ref="UsMapSvg" style="margin: 0 auto;"></div>
    </div>
</div>
</template>
<script>
import CONSTANTS from '../../../config/constant'
import d3 from 'd3'

var epsilon = 0.000001
function geoAlbersUsaPr () {
  var cache
  var cacheStream
  var lower48 = d3.geo.albers(); var lower48Point
  var alaska = d3.geo.conicEqualArea().rotate([154, 0]).center([-2, 58.5]).parallels([55, 65])
  var alaskaPoint
  var hawaii = d3.geo.conicEqualArea().rotate([157, 0]).center([-3, 19.9]).parallels([8, 18])
  var hawaiiPoint
  var puertoRico = d3.geo.conicEqualArea().rotate([66, 0]).center([0, 18]).parallels([8, 18])
  var puertoRicoPoint
  var virginIslands = d3.geo.conicEqualArea().rotate([66, 0]).center([0, 18]).parallels([8, 18])
  var virginIslandsPoint
  var guamMariana = d3.geo.conicEqualArea().rotate([-145, 0]).center([0, 16]).parallels([10, 20])
  var guamMarianaPoint

  var mariana = d3.geo.conicEqualArea().rotate([-145, 0]).center([0, 16]).parallels([10, 20])
  var marianaPoint

  var americanSamoa = d3.geo.conicEqualArea().rotate([170, 0]).center([0, -14]).parallels([-14, 0])
  var americanSamoaPoint
  var point
  var pointStream = { point: function (x, y) { point = [x, y] } }

  function albersUsa (coordinates) {
    var x = coordinates[0]; var y = coordinates[1]
    point = (null,
    (lower48Point.point(x, y), point) ||
    (alaskaPoint.point(x, y), point) ||
    (hawaiiPoint.point(x, y), point) ||
    (puertoRicoPoint.point(x, y), point) ||
    (virginIslandsPoint.point(x, y), point) ||
    (guamMarianaPoint.point(x, y), point) ||
    (marianaPoint.point(x, y), point) ||
    (americanSamoaPoint.point(x, y), point))

    return point
  }

  albersUsa.invert = function (coordinates) {
    var k = lower48.scale()
    var t = lower48.translate()
    var x = (coordinates[0] - t[0]) / k
    var y = (coordinates[1] - t[1]) / k
    return (y >= 0.120 && y < 0.234 && x >= -0.425 && x < -0.214 ? alaska
      : y >= 0.166 && y < 0.234 && x >= -0.214 && x < -0.115 ? hawaii
        : y >= 0.204 && y < 0.234 && x >= 0.300 && x < 0.380 ? puertoRico
          : y >= 0.204 && y < 0.234 && x >= 0.300 && x < 0.380 ? virginIslands
            : y >= 0.050 && y < 0.204 && x >= 0.340 && x < 0.380 ? guamMariana
              : y >= 0.050 && y < 0.204 && x >= 0.340 && x < 0.380 ? mariana
                : y >= 0.160 && y < 0.204 && x >= 0.280 && x < 0.340 ? americanSamoa
                  : lower48).invert(coordinates)
  }

  albersUsa.stream = function (stream) {
    cache = cache && cacheStream === stream ? cache : cache = multiplex([lower48.stream(cacheStream = stream), alaska.stream(stream), hawaii.stream(stream), puertoRico.stream(stream), virginIslands.stream(stream), guamMariana.stream(stream), mariana.stream(stream), americanSamoa.stream(stream)])
    return cache
  }

  albersUsa.precision = function (_) {
    if (!arguments.length) return lower48.precision()
    lower48.precision(_)
    alaska.precision(_)
    hawaii.precision(_)
    puertoRico.precision(_)
    virginIslands.precision(_)
    guamMariana.precision(_)
    mariana.precision(_)
    americanSamoa.precision(_)
    return reset()
  }

  albersUsa.scale = function (_) {
    if (!arguments.length) return lower48.scale()
    lower48.scale(_)
    alaska.scale(_ * 0.35)
    hawaii.scale(_)
    puertoRico.scale(_ * 3.5)
    virginIslands.scale(_ * 7.5)
    guamMariana.scale(_ * 6.0)
    mariana.scale(_ * 8.0)
    americanSamoa.scale(_ * 8.0)
    return albersUsa.translate(lower48.translate())
  }

  albersUsa.translate = function (_) {
    if (!arguments.length) return lower48.translate()
    var k = lower48.scale(); var x = +_[0]; var y = +_[1]

    lower48Point = lower48
      .translate(_)
      .clipExtent([[x - 0.455 * k, y - 0.238 * k], [x + 0.455 * k, y + 0.238 * k]])
      .stream(pointStream)

    alaskaPoint = alaska
      .translate(
        [
          x - 0.310 * k,
          y + 0.201 * k
        ]
      )
      .clipExtent(
        [
          [
            x - 0.425 * k + epsilon,
            y + 0.120 * k + epsilon
          ],
          [
            x - 0.214 * k - epsilon,
            y + 0.234 * k - epsilon
          ]
        ]
      )
      .stream(pointStream)

    hawaiiPoint = hawaii
      .translate(
        [
          x - 0.205 * k,
          y + 0.212 * k
        ]
      )
      .clipExtent(
        [
          [
            x - 0.214 * k + epsilon,
            y + 0.166 * k + epsilon
          ],
          [
            x - 0.115 * k - epsilon,
            y + 0.234 * k - epsilon
          ]
        ]
      )
      .stream(pointStream)

    puertoRicoPoint = puertoRico
      .translate(
        [
          x - 0.250 * k, /* move left to right */
          y + 0.330 * k /* move up and down */
        ]
      )
      .clipExtent([
        [
          x - 0.410 * k, /* width left to right -> */
          y + 0.000 * k /* width top to bottom */
        ],
        [
          x - 0.200 * k, /* width right to left <- */
          y + 0.354 * k /* width bottom to top */
        ]
      ])
      .stream(pointStream).point

    virginIslandsPoint = virginIslands
      .translate(
        [
          x - 0.250 * k,
          y + 0.314 * k
        ]
      )
      .clipExtent(
        [
          [
            x - 0.150 * k,
            y + 0.054 * k
          ],
          [
            x + 0.400 * k,
            y + 0.354 * k
          ]
        ]
      )
      .stream(pointStream).point

    guamMarianaPoint = guamMariana
      .translate(
        [
          x + 0.035 * k,
          y + 0.040 * k
        ]
      )
      .clipExtent(
        [
          [
            x - 0.240 * k,
            y + 0.250 * k
          ],
          [
            x + 0.300 * k,
            y + 0.334 * k
          ]
        ]
      )
      .stream(pointStream).point

    marianaPoint = mariana
      .translate(
        [
          x + 0.050 * k,
          y + 0.190 * k
        ]
      )
      .clipExtent(
        [
          [
            x + 0.050 * k,
            y + 0.160 * k
          ],
          [
            x + 0.350 * k,
            y + 0.400 * k
          ]
        ]
      )
      .stream(pointStream).point

    americanSamoaPoint = americanSamoa
      .translate(
        [
          x + 0.350 * k,
          y + 0.260 * k
        ]
      )
      .clipExtent(
        [
          [
            x - 0.500 * k,
            y + 0.150 * k
          ],
          [
            x + 0.500 * k,
            y + 0.314 * k
          ]
        ]
      )
      .stream(pointStream).point

    return reset()
  }

  function reset () {
    cache = cacheStream = null
    return albersUsa
  }
  function multiplex (streams) {
    return {
      point (x, y) { for (const s of streams) s.point(x, y) },
      sphere () { for (const s of streams) s.sphere() },
      lineStart () { for (const s of streams) s.lineStart() },
      lineEnd () { for (const s of streams) s.lineEnd() },
      polygonStart () { for (const s of streams) s.polygonStart() },
      polygonEnd () { for (const s of streams) s.polygonEnd() }
    }
  }
  return albersUsa.scale(1070)
}

export default {
  name: 'HomePageMap',
  data: () => ({
    mapLoader: false
  }),
  mounted () {
    this.drawMap()
  },
  methods: {
    /**
     * // Map related functions
      */
    drawMap () {
      const container = this.$refs.UsMapSvg
      container.innerHTML = ''
      // eslint-disable-next-line
      const datamap = new Datamap({
        element: container,
        scope: 'usa',
        geographyConfig: {
          hideAntarctica: false,
          popupTemplate: (geo) =>
            '<div class="hoverinfo">' + geo.properties.name + '</div>',
          popupOnHover: true, // True to show the popup while hovering
          highlightOnHover: true,
          highlightFillColor: '#FFA201',
          highlightBorderColor: '#FFFFFF'
        },
        setProjection: function (element) {
          var projection = geoAlbersUsaPr()
            .scale(element.offsetWidth)
            .translate([element.offsetWidth / 2, element.offsetHeight / 2])
          var path = d3.geo.path().projection(projection)
          return { path: path, projection: projection }
        },
        responsive: true,
        fills: {
          defaultFill: 'rgb(235, 241, 244)'
        },
        data: {},
        done: datamap => {
          datamap.svg.selectAll('.datamaps-subunit').on('click', geography => {
            this.mapLoader = true
            const formData = {
              code: geography.id,
              isAbbreviation: true,
              codeLevel: CONSTANTS.STATE_LEVEL,
              parentCode: '',
              parentLevel: CONSTANTS.ABBR_PARENT_LEVEL
            }
            this.$globalStates.notification.init_notifications = false
            new Promise((resolve, reject) => {
              this.$store.dispatch('AuthModule/fetchFeToken', { resolve, reject })
            }).then((tokenData) => {
              let tokens = tokenData.data
              this.$store.dispatch('AuthModule/setJWTTokens', { tokens }).then(() => {
                new Promise((resolve, reject) => {
                  this.$store.dispatch('FEMapModule/getNameFromAbbreviationList', {
                    resolve,
                    reject,
                    formData
                  })
                })
                  .then(responseData => {
                    if (responseData.list.codeAbbr !== '') {
                      let stateEntityName = responseData.list.codeName.replace(/\s+/g, '-')
                      let StateTitle = stateEntityName.charAt(0).toLowerCase() + stateEntityName.slice(1)
                      let routerData = this.$router.resolve({ name: 'StateCodeAdoption', params: { countryName: 'usa', stateName: StateTitle.toLowerCase(), pageId: true } })
                      window.open(routerData.href, '_blank')
                      this.$store.commit('FESearchModule/setCheckBookMarkSearchAPI', false)
                      this.mapLoader = false
                    } else {
                      this.mapLoader = false
                      this.$globalStates.notification.type = 'error'
                      this.$globalStates.notification.text = this.$globalFromValidation.getErrorMessageText(CONSTANTS.MAP_STATE_NOT_FOUND)
                      this.$globalStates.notification.init_notifications = true
                    }
                  })
                  .catch(() => {
                    this.mapLoader = false
                  })
              }).catch()
            }).catch()
          })
          window.addEventListener('resize', function () {
            datamap.resize()
          })
        }
      })
      datamap.labels()
    }
  }
}
</script>
